import { WidgetFormSubmissionWithWidget } from "@closerplatform/spinner-openapi";
import { UserAnswers } from "../types";
import { createUserAnswersFromUserInputs } from "./ordinaryFormUtils";

export enum OplAddressFormInputs {
  City = "city",
  Street = "street",
  StreetNumber = "streetNumber",
  ApartmentNumber = "apartmentNumber",
  NoStreet = "noStreet",
  ZipCode = "zipCode"
}

export const createOplAddressUsersAnswers = ({
  userInputs
}: WidgetFormSubmissionWithWidget): UserAnswers => {
  if (userInputs) {
    return createUserAnswersFromUserInputs(userInputs);
  }

  return {
    [OplAddressFormInputs.City]: { inputName: OplAddressFormInputs.City, value: "" },
    [OplAddressFormInputs.Street]: { inputName: OplAddressFormInputs.Street, value: "" },
    [OplAddressFormInputs.NoStreet]: { inputName: OplAddressFormInputs.NoStreet, value: "" },
    [OplAddressFormInputs.StreetNumber]: {
      inputName: OplAddressFormInputs.StreetNumber,
      value: ""
    },
    [OplAddressFormInputs.ApartmentNumber]: {
      inputName: OplAddressFormInputs.ApartmentNumber,
      value: ""
    },
    [OplAddressFormInputs.ZipCode]: { inputName: OplAddressFormInputs.ZipCode, value: "" }
  };
};
